/* eslint-disable sort-keys */
import React from 'react';

import {
  MyBusiness,
  MyBusinessFilled,
  MyBusinessHover,
} from '@im/ui-lib/icons/nav/MyBusiness';

import {
  Products,
  ProductsHover,
  ProductsFilled,
} from '@im/ui-lib/icons/nav/Products';

import {
  Vendors,
  VendorsFilled,
  VendorsHover,
} from '@im/ui-lib/icons/nav/Vendors';

import {
  DataIngestion,
  DataIngestionFilled,
  DataIngestionHover,
} from '@im/ui-lib/icons/nav/DataIngestion';

import { Help, HelpFilled, HelpHover } from '@im/ui-lib/icons/nav/Help';

import {
  Solutions,
  SolutionsFilled,
  SolutionsHover,
} from '@im/ui-lib/icons/nav/Solutions';

import {
  Services,
  ServicesFilled,
  ServicesHover,
} from '@im/ui-lib/icons/nav/Services';

import {
  Bundles,
  BundlesFilled,
  BundlesHover,
} from '@im/ui-lib/icons/nav/Bundles';

import {
  BusinessPlanning,
  BusinessPlanningFilled,
  BusinessPlanningHover,
} from '@im/ui-lib/icons/nav/BusinessPlanning';

import {
  Settings,
  SettingsFilled,
  SettingsHover,
} from '@im/ui-lib/icons/nav/Settings';

import { Events, EventsHover, EventsFilled } from '@im/ui-lib/icons/nav/Events';

import {
  Resources,
  ResourcesHover,
  ResourcesFilled,
} from '@im/ui-lib/icons/nav/Resources';

import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';

import { Home } from '../../icons/Home';
import { HomeFilled } from '../../icons/HomeFilled';

const BidManagementHub: React.FC = () => (
  <AssignmentTurnedInOutlinedIcon
    color="disabled"
    sx={{ width: 24, height: 24 }}
  />
);
const BidManagementHubFilled: React.FC = () => (
  <AssignmentTurnedInIcon color="primary" sx={{ width: 24, height: 24 }} />
);
const AuditLogs: React.FC = () => (
  <WorkHistoryOutlinedIcon color="disabled" sx={{ width: 24, height: 24 }} />
);

const AuditLogsFilled: React.FC = () => (
  <WorkHistoryIcon color="primary" sx={{ width: 24, height: 24 }} />
);
type SideBarButtonKey =
  | 'home'
  | 'myBusiness'
  | 'products'
  | 'help'
  | 'vendors'
  | 'solutions'
  | 'services'
  | 'resources'
  | 'events'
  | 'bundles'
  | 'business'
  | 'settings'
  | 'dataingestion'
  | 'bidManagementHub'
  | 'auditLogs';

const icons: {
  [k in SideBarButtonKey]: {
    active: React.FC;
    default: React.FC;
    hover: React.FC;
  };
} = {
  home: { active: HomeFilled, default: Home, hover: HomeFilled },
  myBusiness: {
    active: MyBusinessFilled,
    default: MyBusiness,
    hover: MyBusinessHover,
  },
  products: { active: ProductsFilled, default: Products, hover: ProductsHover },
  vendors: { active: VendorsFilled, default: Vendors, hover: VendorsHover },
  help: { active: HelpFilled, default: Help, hover: HelpHover },
  solutions: {
    active: SolutionsFilled,
    default: Solutions,
    hover: SolutionsHover,
  },
  services: { active: ServicesFilled, default: Services, hover: ServicesHover },
  events: {
    active: EventsFilled,
    default: Events,
    hover: EventsHover,
  },
  resources: {
    active: ResourcesFilled,
    default: Resources,
    hover: ResourcesHover,
  },
  bundles: {
    active: BundlesFilled,
    default: Bundles,
    hover: BundlesHover,
  },
  business: {
    active: BusinessPlanningFilled,
    default: BusinessPlanning,
    hover: BusinessPlanningHover,
  },
  dataingestion: {
    active: DataIngestionFilled,
    default: DataIngestion,
    hover: DataIngestionHover,
  },
  bidManagementHub: {
    active: BidManagementHubFilled,
    default: BidManagementHub,
    hover: BidManagementHub,
  },
  settings: {
    active: SettingsFilled,
    default: Settings,
    hover: SettingsHover,
  },
  auditLogs: {
    active: AuditLogsFilled,
    default: AuditLogs,
    hover: AuditLogs,
  },
};

export function renderSideNavItemIcon(
  key: string,
  active: boolean,
  hover: boolean
) {
  const map = icons[key as SideBarButtonKey];
  if (!map) {
    return null;
  }

  let Icon = map.default;
  if (active) {
    Icon = map.active;
  } else if (hover) {
    Icon = map.hover;
  }

  return <Icon />;
}
